import { useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
import Search from '../lib/search';
import { InstrumentGroup, Facets } from '../models/search';
import { parseSectionsResults, formatSummary } from '../utils/search-utils';

interface UseInstantSearchValue {
  isLoading: boolean;
  results?: any[] | null;
  facets?: Facets;
}

const useInstantSearch = (
  query?: string | null,
  instrumentParam = InstrumentGroup.Guitar,
): UseInstantSearchValue | null => {
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState<null | any[]>();
  const [facets, setFacets] = useState<Facets>();

  useEffect((): any => {
    if (!query) return undefined;
    setIsLoading(true);
    const getInstantResults = async (): Promise<any> => {
      try {
        const rawResults = await Search.sectionsSearch(query, instrumentParam, null);
        if (rawResults) {
          const parsedResults = parseSectionsResults(rawResults);
          const { facets: resultFacets, hits, query: resultQuery, queryID } = parsedResults ?? {};
          const formattedResults = formatSummary(
            hits,
            resultFacets as Facets,
            resultQuery,
            InstrumentGroup.Guitar,
            queryID,
            {},
            10,
          );
          setResults(formattedResults);
          setFacets(resultFacets);
          setIsLoading(false);
        }
      } catch (e) {
        console.error(e);
        setResults(null);
        setIsLoading(false);
      }
    };
    const debouncedInstantResults = debounce(getInstantResults, 500);
    debouncedInstantResults();

    return (): void => {
      debouncedInstantResults.cancel();
    };
  }, [query, instrumentParam]);
  return { isLoading, results, facets };
};

export default useInstantSearch;
